/*import 'jquery';
*/
import {Popper} from '@popperjs/core';
import { Dropdown } from "bootstrap";
import { Splide } from '@splidejs/splide';
import 'jquery-match-height-browserify';
import "lazysizes";
import '@splidejs/splide/dist/css/splide.min.css';
import './select-office-by-county.js';

// Make Vue available globally (as suggested in previous solution)

//import 'googlemaps';
//import 'GMaps';
//import "sticky-kit/dist/sticky-kit.js";

document.addEventListener('DOMContentLoaded', function() {
  // Initialize Bootstrap 5 dropdowns
  var dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'));
  var dropdownList = dropdownElementList.map(function (dropdownToggleEl) {
    return new Dropdown(dropdownToggleEl, {
      // Optional: prevent auto-close when clicking inside dropdown
      autoClose: 'outside'
    });
  });

  // Optional: Add hover functionality for desktop
  const mediaQuery = window.matchMedia('(min-width: 768px)');
  if (mediaQuery.matches) {
    document.querySelectorAll('.dropdown').forEach(function(dropdown) {
      dropdown.addEventListener('mouseenter', function() {
        const dropdownToggle = this.querySelector('.dropdown-toggle');
        const dropdownInstance = Dropdown.getInstance(dropdownToggle);
        if (dropdownInstance) {
          dropdownInstance.show();
        }
      });

      dropdown.addEventListener('mouseleave', function() {
        const dropdownToggle = this.querySelector('.dropdown-toggle');
        const dropdownInstance = Dropdown.getInstance(dropdownToggle);
        if (dropdownInstance) {
          dropdownInstance.hide();
        }
      });
    });
  }

  // Handle mobile menu toggle
  const menuToggle = document.querySelector('.header-nav__toggle');
  const navigation = document.querySelector('.header-nav__navigation');

  if (menuToggle && navigation) {
    menuToggle.addEventListener('click', function() {
      navigation.classList.toggle('is-visible');
    });
  }
});




document.addEventListener("lazybeforeunveil", function (e) {
  var bg = e.target.getAttribute("data-bg");
  if (bg) {
    e.target.style.backgroundImage = "url(" + bg + ")";
  }
});

var loaded = false;

$(document).ready(function () {
  var whatOffice = 0;

  $(".js-toggle-search").on("click", function () {
    $(".js-search-bar").toggleClass("is-visible");
    $(".js-header-nav").toggleClass("has-search-visible");
    if ($(".js-search-bar").hasClass("is-visible")) {
      $(".js-search-form > input").focus();
    } else {
      $(".js-search-form").blur();
    }
  });

  $(".js-toggle-nav").on("click", function (e) {
    e.preventDefault();
    $(".js-navigation").toggleClass("is-visible");
    if ($(".js-navigation").hasClass("is-visible")) {
      $(".js-navigation > ul").focus(); // set focus.
      $("body").addClass("is-locked"); //
    } else {
      $(".header-nav__toggle.js-toggle-nav").focus();
      $("body").removeClass("is-locked");
    }
  });

  $(".js-file").on("change", function (e) {
    var file = $(this)[0].files[0];
    var t = $(this);
    if (file) {
      //$(this).find('span').html('hei');
      //t.find('.has-files').html('test');
      t.next(".input__label").find("span.has-files").text(file.name);
      t.next(".input__label").find("span.no-files").hide();
    } else {
      //$(this).find('span').html('hei');
      t.next(".input__label").find("span.has-files").text("");
      t.next(".input__label").find("span.no-files").show();
    }
  });

  $(".js-counter").each(function () {
    var $this = $(this),
      countTo = $this.attr("data-count"),
      countSpeed = $this.attr("data-count-speed");
    $({
      countNum: $this.text(),
    }).animate(
      {
        countNum: countTo,
      },
      {
        duration: 0,
        easing: "linear",
        step: function () {
          $this.text(Math.floor(this.countNum));
        },
        complete: function () {
          $this.text(this.countNum);
          //alert('finished');
        },
      }
    );
  });

  $(function () {
    $(".js-equal-height").matchHeight();
  });

  // Select all links with hashes
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .not(".collapsable-element")
    .click(function (event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $("html, body").animate(
            {
              scrollTop: target.offset().top,
            },
            1000,
            function () {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) {
                // Checking if the target was focused
                return false;
              } else {
                $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            }
          );
        }
      }
    });

  var map = "";

  function initMap() {
    //var data = window.trafficData;
    var maps = $(".js-maps");
    var zoomLevel = $(".js-maps").data("zoom-level");
    var isSingle = $(".js-maps").data("type-single");

    // set default zoom to be used if type-single != true.
    var lat = 64.5602358,
      lng = 12.476;

    if (isSingle === true) {
      var target = $(".js-maps .js-office-marker");
      lat = target.data("map-lat");
      lng = target.data("map-lng");
      //console.log(lat + lng);
    }

    // center map

    // build map
    const mapsView = {
      div: "#map",
      lat: lat,
      lng: lng,
      zoom: zoomLevel,
      markerClusterer: function (map) {
        let options = {
          gridSize: 20,
          styles: [
            {
              textColor: "white",
              url: "/img/clustermarker.png",
              height: 30,
              width: 30,
            },
          ],
        };

        return new MarkerClusterer(map, [], options);
      },
      styles: [
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#e9e9e9",
            },
            {
              lightness: 17,
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "geometry",
          stylers: [
            {
              color: "#f5f5f5",
            },
            {
              lightness: 20,
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#ffffff",
            },
            {
              lightness: 17,
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#ffffff",
            },
            {
              lightness: 29,
            },
            {
              weight: 0.2,
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "geometry",
          stylers: [
            {
              color: "#ffffff",
            },
            {
              lightness: 18,
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "geometry",
          stylers: [
            {
              color: "#ffffff",
            },
            {
              lightness: 16,
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [
            {
              color: "#f5f5f5",
            },
            {
              lightness: 21,
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [
            {
              color: "#dedede",
            },
            {
              lightness: 21,
            },
          ],
        },
        {
          elementType: "labels.text.stroke",
          stylers: [
            {
              visibility: "on",
            },
            {
              color: "#ffffff",
            },
            {
              lightness: 16,
            },
          ],
        },
        {
          elementType: "labels.text.fill",
          stylers: [
            {
              saturation: 36,
            },
            {
              color: "#333333",
            },
            {
              lightness: 40,
            },
          ],
        },
        {
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "transit",
          elementType: "geometry",
          stylers: [
            {
              color: "#f2f2f2",
            },
            {
              lightness: 19,
            },
          ],
        },
        {
          featureType: "administrative",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#fefefe",
            },
            {
              lightness: 20,
            },
          ],
        },
        {
          featureType: "administrative",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#fefefe",
            },
            {
              lightness: 17,
            },
            {
              weight: 1.2,
            },
          ],
        },
      ],
    };

    map = new GMaps(mapsView);

    var marker = $(".js-office-marker"); // all markers.
    var markers = [];

    $.each(marker, function () {
      markers += marker;
    });

    $.each(marker, function (i, item) {
      var icon = {
        //scaledSize: new google.maps.Size(25, 16), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(0, 0), // anchor,
        //imagePath: "/img/pin.png"
      };
      var t = $(this);

      map.addMarker({
        lat: t.data("map-lat"),
        lng: t.data("map-lng"),
        title: t.data("map-title"),
        icon: "/img/pin.png",

        // icon: icon,
        click: function (e) {
          // center this
          map.map.panTo(e.position);
          //map.setZoom(17);
        },
        infoWindow: {
          content:
            "<strong>" +
            t.data("map-title") +
            "</strong><br>" +
            t.data("map-address") +
            '<br><a href="' +
            t.data("map-link") +
            '">Se kontorets nettside</a>',
        },
      });
    });
  }

  // $('#officeselect').on('change', function(e) {
  //     //var target = $(this).data('target');
  //     //target = 0;
  //     var target = $('#officeselect option:selected').val();
  //     e.preventDefault();
  //     map.hideInfoWindows(); // hide all then open
  //     if(loaded){
  //         map.setZoom(17);
  //         map.panTo(map.markers[target].position);
  //     }

  //    (map.markers[target].infoWindow).open(map.map,map.markers[target]);
  // });

  function pythagorasEquirectangular(lat1, lon1, lat2, lon2) {
    lat1 = deg2Rad(lat1);
    lat2 = deg2Rad(lat2);
    lon1 = deg2Rad(lon1);
    lon2 = deg2Rad(lon2);

    const R = 6371;
    let x = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2);
    let y = lat2 - lat1;
    let d = Math.sqrt(x * x + y * y) * R;

    return d;
  }

  function deg2Rad(deg) {
    return (deg * Math.PI) / 180;
  }

  function nearestOffice(latitude, longitude) {
    let locations = [];
    let closest;

    $(".js-maps .js-office-marker").each(function () {
      if ($(this)[0].hasAttribute("data-map-lng")) {
        locations.push([
          $(this).attr("data-map-lat"),
          $(this).attr("data-map-lng"),
        ]);
      }
    });

    let mindiff = 99999;

    for (let i = 0; i < locations.length; i++) {
      var diff = pythagorasEquirectangular(
        latitude,
        longitude,
        locations[i][0],
        locations[i][1]
      );

      if (diff < mindiff) {
        closest = i;
        mindiff = diff;
        //console.log(closest)
      } else {
        // User is too far away ?
      }
    }

    $(".js-maps").data("office", closest);

    setOffice(closest);
  }

  function setOffice(closest) {
    $(".js-maps").data("office", closest);
    $("#officeselect").val(closest).change().trigger("click");
  }

  var checkMap = $(".js-maps");
  if (checkMap.length >= 1) {
    initMap();

    if (navigator.geolocation) {
      jQuery
        .post(
          "https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyAf1Ek03p8FiQL6lMKqokpna2F3VJ-jSfY",
          function (success) {
            if ($("#officeselect").length) {
              nearestOffice(success.location.lat, success.location.lng);
            } else {
            }
          }
        )
        .fail(function (err) {
          setOffice(0);
          console.log("error for location");
        });
    } else {
      setOffice(0);
    }
  }
});

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

$(window).scroll(function () {
  if ($(window).scrollTop() >= 300) {
    $(".js-header-nav").addClass("is-stuck");
  } else {
    $(".js-header-nav").removeClass("is-stuck");
  }
});

function toggleMarker(selected) {
  var target = selected;
}

//var offices = window.offices;



/*Vue.component("single-office", {
  template:
    '<div class="offices__office"><h3 class="h4">{{data.name}}</h3><p>{{data.adress}}</p><p  v-if="data.email.length > 2"><strong>Epost:</strong> <span v-html="this.email(data.email)"></span></p><p v-if="data.phone.length > 2"><strong>Telefon:</strong> <span v-html="this.phone(data.phone)"></span></p><p v-if="data.link.length > 2"><span v-html="this.link(data.link)"></span></p></div>',
  props: ["data"],
  methods: {
    email: function (email) {
      let emailMarkup = '<a href="mailto:' + email + '">' + email + "</a>";
      return emailMarkup;
    },
    link: function (link) {
      let linkMarkup =
        '<a href="' +
        link +
        '" class="btn btn--red btn--medium">Se kontorets nettside</a>';
      return linkMarkup;
    },
    phone: function (phone) {
      let phoneNoSpaces = phone.replace(/\s/g, "");
      let phoneMarkup = '<a href="tel:' + phoneNoSpaces + '">' + phone + "</a>";
      return phoneMarkup;
    },
  },
});*/

/*Vue.component('single-office', {
  props: ['data'],
  template: `
       <div class="office-details">
         <h3>{{ data.name }}</h3>
         <p>{{ data.adress }}</p>
         <p v-if="data.addressPostal">{{ data.addressPostal }}</p>
         <p v-if="data.email">Email: {{ data.email }}</p>
         <p v-if="data.phone">Telefon: {{ data.phone }}</p>
         <a :href="data.link" class="btn btn-primary">Besøk kontor</a>
       </div>
     `
});*/

/*document.addEventListener('DOMContentLoaded', function() {
  const office = document.querySelector("#office");
  if (office !== null) {
    // Get offices data from wherever it's available
    const offices = window.offices || []; // Use global variable if available

    var app = new Vue({
      el: "#office",
      methods: {
        myFilter(option, label, search) {
          const temp = search.toLowerCase();
          return (
              option.adress.toLowerCase().includes(temp) ||
              option.county.toLowerCase().includes(temp) ||
              option.name.toLowerCase().includes(temp) ||
              option.addressPostal.toLowerCase().includes(temp)
          );
        },
        setSelected(selected) {
          if (selected) {
            this.selected = selected;
            this.current = selected.name;
          }
        },
      },
      mounted() {
        this.sortedOffices = this.offices.sort((a, b) =>
            a.name.localeCompare(b.name)
        );
      },
      data: {
        selected: null,
        current: null,
        offices: offices,
        sortedOffices: null,
      },
    });
  }
});*/



// SPLIDE SLIDER

function initSplideHeaderSliders() {
  const sliders = document.querySelectorAll(".splide-header");
  for (let i = 0; i < sliders.length; i++) {
    new Splide(sliders[i], {
      type: "loop",
      autoplay: true,
      interval: 1000,
      perPage: 2,
      updateOnMove: true,
      pagination: false,
      gap: 20,
      rewind: true, // Only needed for fade if we want it to loop
    }).mount();
    sliders[i].classList.add("splide-header-" + i);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  initSplideHeaderSliders();
});